import { render } from "./TeachersContent.vue?vue&type=template&id=241b6be8&ts=true"
import script from "./TeachersContent.vue?vue&type=script&lang=ts"
export * from "./TeachersContent.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__